import { useContext } from 'react'
import { useSubscription } from '@apollo/client'
import { PaymentMethodsContext } from 'Shared/PaymentMethods'
import onInstallmentPayment from 'AccountsPayment/Apollo/Subscriptions/onInstallmentPayment'

export const useTerminalInvoiceSubscription = ({ isOpen } = { isOpen: false }) => {
  const { mutation } = useContext(PaymentMethodsContext)
  const { state, uuid } = mutation.data
  const { data } = useSubscription(onInstallmentPayment, {
    variables: {
      isOpen,
      scope: {
        currentInstallment: uuid,
      },
    },
    shouldResubscribe: true,
    skip: state === 'paid',
  })

  const { failedReason, state: paymentState } = data?.installmentPayment?.installment?.payment || {}

  const isCompleted = ['processing', 'completed'].includes(paymentState)
  const isFailed = paymentState === 'failed'

  return { failedReason, isCompleted, isFailed }
}
